import React from 'react';
import classNames from 'classnames';
import {Col, Panel, Row} from 'react-bootstrap';
import ArrowButton from '../../../common/button-arrow';

const ProductItem = ({
  item, status, image, categoryName, deleteDisabled, editDisabled, itemType, ...props
}) => {
  const statusClass = classNames('product-status', (status ? status.toLowerCase() : ''));

  return (
    <Panel className="product-item">
      <Row>
        <Col md={8} style={{userSelect: 'none'}}>
          {image && <img className="imgPreview" src={image}/>}
          {(status === 'INACTIVE' || status === 'DRAFT') && (
            <span className={statusClass}>
              {status}
            </span>
          )}
          {item.name || item.attributes.name}
          {
            categoryName && (
              <span className="category-name">
Category:
                <span>
                  {categoryName}
                </span>
              </span>
            )
          }
          {
            categoryName && status === 'INACTIVE' && (
              <span className={statusClass}>
                {status}
              </span>
            )
          }
        </Col>
        <Col md={4}>
          <ArrowButton
            arrow={false}
            className="pull-right"
            disabled={!!deleteDisabled}
            onClick={() => props.onDelete(item.id)}
            permissions={{
              action: 'destroy',
              subjectClass: itemType
            }}
            submit={false}
          >
            Delete
          </ArrowButton>
          <ArrowButton
            arrow={false}
            className="pull-right"
            color="grey"
            disabled={!!editDisabled}
            onClick={() => props.onEdit(item.id)}
            permissions={{
              action: 'update',
              subjectClass: itemType
            }}
            submit={false}
          >
            Edit
          </ArrowButton>
        </Col>
      </Row>
    </Panel>
  );
};

export default ProductItem;



// WEBPACK FOOTER //
// ./src/components/admin/products/common/product-item.jsx